import { LoaderCircle } from 'lucide-react';

export const RecordingCompletingSpinner = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <LoaderCircle className="h-8 w-8 animate-spin" />
        <div className="text-center">
          <p className="text-lg font-medium text-gray-900">Finalizing recording...</p>
          <p className="text-sm text-gray-500">Please wait while we process your transcript</p>
        </div>
      </div>
    </div>
  );
};

export const RecordingLoadingSpinner = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex items-center gap-3">
        <LoaderCircle className="h-6 w-6 animate-spin" />
        <span className="text-gray-600">Loading transcript...</span>
      </div>
    </div>
  );
};
